<template>
  <v-container>
    <CommissionersPropertyCriteria :baseCrudKey="baseCrudKey" :isPulling="isPullingCountyOwned"
      @loadCRUDList="handleLoadList" @pullCountyOwnedRecords="pullCountyOwnedRecords" />
    <template>
      <v-row>
        <v-col cols="12">
          <CRUDList ref="crudList" :canAdd="false" :canEdit="true" :canCancel="true"
            :canSave="true" :showSelect="false" :canDeleteInDialog="true"
            :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
            :baseCrudKey="baseCrudKey" :dialogHeaderName="dialogHeaderName"
            :defaultSortBy="defaultSortBy" dialogDynamicWidth="60vw"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table' tableDynamicHeight="250"
            @loadCRUDList="handleLoadList" :loadingData="gridLoading.flag"
            @upsertItem="upsertRecords" @deleteItem="deleteFromDiaglog"
            @onSingleClicked="handleSingleOrArrowClick" @onArrowUpOrDown="handleSingleOrArrowClick"
            :loadingText="gridLoading.text">
            <template v-slot:additionalActionsTopAboveRow>
                <v-row class="pa-0 mb-n10">
                <v-col cols="11"></v-col>
                <v-col cols="1">
                    <v-btn color="primary" fab icon small class="ml-n1"
                    @click="openAddNewRecordDialog()">
                    <v-icon small>
                        {{icons.mdiPlus}}
                    </v-icon>
                    </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:[`editedItem`]="{ }">
              <CommissionersPropertyListDialog :baseCrudKey="baseCrudKey" @loadCRUDList="handleLoadList"
              :saleYear="criteriaState.saleYear" :baseCrudKeyForBidderDetails="baseCrudKeyForBidderDetails"
              @upsertTransaction="upsertTransaction" @deleteTransaction="deleteTransaction"
              :baseCrudKeyForBidderRegistration="baseCrudKeyForBidderRegistration" />
            </template>
            <template v-slot:addidtionalCrudFooter>
              <h4 class="input-text-size pt-3 pl-1">RECORD COUNT: {{ recordsCount }}</h4>
            </template>
          </CRUDList>
        </v-col>
      </v-row>
      <CRUDDialog ref="crudDialogForAddNewRecord" :baseCrudKey="baseCrudKeyForAddNewRecord"
        dialogDynamicWidth="30vw" :canSave="false" :canCancel="false"
        onlyDialogHeaderName="Add Record to Commissioners List">
          <template v-slot:[`editedItem`]="{ }">
            <v-text-field class="input-text-size" label="Tax Year(Base Year)"
             v-model.number="addNewRecord.taxYear" type="number" :rules="rules"/>
            <v-text-field class="input-text-size" label="Tax ID" v-model.number="addNewRecord.taxId"
             type="number" :rules="rules" />
            <v-text-field class="input-text-size" label="Sale Year" v-model.number="addNewRecord.saleYear"
             type="number" :rules="rules" />
          </template>
          <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text
          color="blue darken-1" @click="handleAddNewRecord()">
          OK
        </v-btn>
        <v-btn class="input-text-size" text
          color="blue darken-1" @click="closeAddNewRecordDialog()">
          Cancel
        </v-btn>
        </template>
      </CRUDDialog>
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters, mapState,
} from 'vuex';
import { mdiPlus } from '@mdi/js';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { amountToNumber, defaultGridLoading, manageGridLoading } from '../../../../../util/shared/vue-global';
import { toIsoDate } from '../../../../../util/shared/tmc-global';
import CommissionersPropertyCriteria from './CommissionersPropertyCriteria.vue';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import { commissionersSaleCommonPostProcessTrans } from '../../../common-utils/CommonTaxFunctionalities';
import { commissionerMainHeader, commissionersSaleSaveFields } from '../../deliquentUtils/deliquent.utils';
import CommissionersPropertyListDialog from './CommissionersPropertyListDialog.vue';

export default {
  name: 'CommissionersPropertyList',
  components: {
    CRUDList,
    CRUDDialog,
    CommissionersPropertyCriteria,
    CommissionersPropertyListDialog,
  },
  created() {
    this.onCreated();
  },
  data() {
    return {
      baseCrudKey: 'CommissionersPropertyList',
      baseCrudKeyForBidderDetails: 'CommissionersPropertyListForBidder',
      dialogHeaderName: 'Commissioners Sale Record',
      baseCrudKeyForAddNewRecord: 'AddNewRecordToCommissioner',
      baseCrudKeyForBidderRegistration: 'BidderRegistrationBaseCrudKey',
      headers: commissionerMainHeader,
      gridLoading: defaultGridLoading(),
      recordsCount: 0,
      isItFirstCallOrNot: false,
      // the pull waits on the backend bulk writes now, so it can run for several seconds
      // on a large county - without this the button stays live and a second click starts
      // a concurrent pull that upserts the same parcels again
      isPullingCountyOwned: false,
      addNewRecord: {
        taxYear: null,
        taxId: null,
        saleYear: null,
      },
      icons: {
        mdiPlus,
      },
    };
  },
  mounted() {
    if (this.latestSaleYear) {
      this.isItFirstCallOrNot = true;
      this.handleLoadList();
    }
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item', 'criteria']),
    ...mapState({
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
      latestSaleYear: (state) => state.tax.juneResale.latestSaleYear,
      saleYearList: (state) => state.tax.juneResale.saleYearList,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [{ column: 'systemId', direction: 'asc' }];
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
  },
  watch: {
    latestSaleYear(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.saleYear = this.latestSaleYear;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadList();
      }
    },
    isVisibleResaleList(val) {
      if (val) this.setDefaultSelectedItems();
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setItem', 'setItems', 'setCriteria', 'setHighlightedId', 'setIsVisible']),
    ...mapActions(['reAuth']),
    ...mapActions('tax/commissionersSale', [
      'loadCommissionersSale',
      'pullAllRecordsForCurrentCommissionersSale',
      'getCommissionersSaleCountBasedOnSaleYear',
      'addANewRecordToCommissionersSale',
      'upsertCommissionersSaleSelectedFields',
      'deleteCommissionersSale',
      'upsertCommissionersSale',
    ]),
    ...mapActions('tax/juneResale', [
      'bidderRegistration',
    ]),
    postProcessForResaleList(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const alteredItems = commissionersSaleCommonPostProcessTrans(items, formatPidPositions);
      return alteredItems;
    },
    async handleLoadList(retaiItemId, systemId) {
      if (this.isItFirstCallOrNot) {
        this.selectedRowData = {};
        manageGridLoading(this, true, 'Searching...');
        const { baseCrudKey, baseCrudKeyForBidderDetails } = this;
        const criteria = {
          ...this.criteriaState,
          isItSold: this.criteriaState.isItSold || false,
          resaleSortByParcelComponents: this.resaleSettingItem.resaleSortByParcelComponents || false,
        };
        const itemToSent = {
          saleYear: Number(criteria.saleYear || 0),
        };
        this.getCommissionersSaleCountBasedOnSaleYear({ itemToSent }).then((res) => {
          this.recordsCount = res || 0;
        });
        this.loadCommissionersSale({
          criteria, baseCrudKey, postProcessTrans: this.postProcessForResaleList,
        }).then((res) => {
          this.setDefaultSelectedItems();
          this.setItems([baseCrudKeyForBidderDetails, []]);
          // this if and else block is nedded when the user delete the records from the dialog
          if (retaiItemId) { // when the user delete the records from the dialog
            const filterItem = (res || []).filter((ft) => ft._id === retaiItemId);
            if (filterItem.length) {
              this.setItem([baseCrudKey, filterItem[0]]);
              if (filterItem[0].bidHistory.length) this.setItems([baseCrudKeyForBidderDetails, filterItem[0].bidHistory]);
              else this.setItems([baseCrudKeyForBidderDetails, []]);
            }
          } else if (systemId) { // when the user pull the current details to the resale list
            const filterItem = (res || []).filter((ft) => ft.systemId === systemId);
            if (filterItem.length) {
              this.setItem([baseCrudKey, filterItem[0]]);
              if (filterItem[0].bidHistory.length) this.setItems([baseCrudKeyForBidderDetails, filterItem[0].bidHistory]);
              else this.setItems([baseCrudKeyForBidderDetails, []]);
            }
          } else {
            this.setItem([baseCrudKey, {}]);
          }
        }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
    openAddNewRecordDialog() {
      this.setIsVisible([this.baseCrudKeyForAddNewRecord, true]);
    },
    closeAddNewRecordDialog() {
      this.addNewRecord = {
        taxYear: null,
        taxId: null,
        saleYear: null,
      };
      this.setIsVisible([this.baseCrudKeyForAddNewRecord, false]);
    },
    handleAddNewRecord() {
      const validate = this.$refs.crudDialogForAddNewRecord.validateForm();
      if (!validate) return;
      const itemToSent = {
        saleYear: Number(this.addNewRecord.saleYear || 0),
        taxId: Number(this.addNewRecord.taxId || 0),
        taxYear: Number(this.addNewRecord.taxYear || 0),
      };
      this.addANewRecordToCommissionersSale({ itemToSent }).then(() => {
        this.closeAddNewRecordDialog();
        this.handleLoadList();
      });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    pullCountyOwnedRecords() {
      if (this.isPullingCountyOwned) return;
      this.isPullingCountyOwned = true;
      this.pullAllRecordsForCurrentCommissionersSale({ itemToSent: {} }).then(() => {
        this.handleLoadList();
      }).finally(() => {
        this.isPullingCountyOwned = false;
      });
    },
    async upsertRecords(item) {
      if (!item._id) return;

      const itemToSent = commissionersSaleSaveFields(item);
      this.upsertCommissionersSaleSelectedFields({ itemToSent }).then(() => {
        this.handleLoadList();
      });
    },
    deleteFromDiaglog(item) {
      if (!item._id) return;
      const itemId = { _id: item._id };
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteCommissionersSale({ item: itemId, baseCrudKey });
      }
    },
    handleSingleOrArrowClick(fromCrud) {
      if ((fromCrud.bidHistory || []).length) {
        this.setItems([this.baseCrudKeyForBidderDetails, fromCrud.bidHistory]);
      } else {
        this.setItems([this.baseCrudKeyForBidderDetails, []]);
      }
    },
    onCreated() {
      const criteria = {
        sortBy: [{ column: 'regNumber', direction: 'asc' }],
      };
      this.bidderRegistration({
        criteria, baseCrudKey: this.baseCrudKeyForBidderRegistration,
      });
    },
    async upsertTransaction(item) {
      const uptItem = item;
      if (Object.values(uptItem).length) {
        const itemList = this.item(this.baseCrudKey);
        itemList.propertyOrParcelId = (itemList.propertyOrParcelId || '').replace(/-/g, '');
        if (uptItem._id) {
          const filterItems = (itemList.bidHistory || [])
            .filter((ft) => ft._id !== uptItem._id);
          const allItems = [...filterItems, { ...uptItem, bidAmount: amountToNumber(uptItem.bidAmount), bidDate: toIsoDate(uptItem.bidDate) }];
          itemList.bidHistory = allItems;
        } else {
          const allItems = [...(itemList.bidHistory || []), { ...uptItem, bidAmount: amountToNumber(uptItem.bidAmount), bidDate: toIsoDate(uptItem.bidDate) }];
          itemList.bidHistory = allItems;
        }
        itemList.commissionerSaleFees = amountToNumber(itemList.commissionerSaleFees);
        if (itemList.commissionerPubDateOne) itemList.commissionerPubDateOne = toIsoDate(itemList.commissionerPubDateOne);
        if (itemList.commissionerPubDateTwo) itemList.commissionerPubDateTwo = toIsoDate(itemList.commissionerPubDateTwo);
        if (itemList.commissionerPubDateThree) itemList.commissionerPubDateThree = toIsoDate(itemList.commissionerPubDateThree);
        if (itemList.commissionerDateOfSale) itemList.commissionerDateOfSale = toIsoDate(itemList.commissionerDateOfSale);
        if (itemList.commissionerDateOfMeeting) itemList.commissionerDateOfMeeting = toIsoDate(itemList.commissionerDateOfMeeting);
        await this.upsertCommissionersSale({
          item: itemList,
        });
        this.handleLoadList(itemList._id);
      }
    },
    async deleteTransaction(item) {
      if (!item._id) return;
      if (!window.confirm('Are you sure you want to delete this item?')) return;
      const itemList = this.item(this.baseCrudKey);
      itemList.propertyOrParcelId = (itemList.propertyOrParcelId || '').replace(/-/g, '');
      itemList.bidHistory = (itemList.bidHistory || [])
        .filter((ft) => ft._id !== item._id);
      await this.upsertCommissionersSale({
        item: itemList,
      });
      this.handleLoadList(itemList._id);
    },
  },
};
</script>
